export default __webpack_public_path__ + "static/media/webpainting3.0afe1179.png";